module.exports = __webpack_public_path__ + "static/media/sound2.691d280.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/sound2.ogg
// module id = +aIY
// module chunks = 3